import styled from 'styled-components';
import { TextView, pd } from '@airasia-phoenix/web';
import Row from '../../Container/Row';

export const color = pd.sys.colour;
export const font = pd.sys.typescale;

export const CardWrapper = styled.div`
  height: 60px;
  background-color: ${color.container_none.color()};
  margin-bottom: -4px;
  border-radius: 4px;
  flex-direction: row;
  margin-top: 4px;
  paddin-top: 8px;
  padding-bottom: 8px;
`;

export const FlightDetails = styled(Row)`
  flex-direction: column;
  margin-left: 16px;
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  margin-top: 5px;
  padding-left: 13px;
  padding-right: 13px;
`;

export const LineContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  max-width: ${({ maxWidth }) => maxWidth || '160px'};
  min-width: ${({ minWidth }) => minWidth || '133px'};
`;

export const Dot = styled.div`
  width: 4px;
  height: 4px;
  background-color: ${color.container_high.color()};
  border-radius: 50%;
  margin-top: -2px;
`;

export const DottedLine = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  height: 1px;
  border-top: 1px dashed ${color.outline_medium.color()};
  margin: 0 3px;
`;

export const MidText = styled(TextView)`
  align-items: center;
  white-space: nowrap;
  display: flex;
  margin-top: -2px;
`;

export const Icon = styled.img`
  margin-left: 4px;
  cursor: pointer;
  height: 12px;
  width: 12px;
`;

export const DatePlus = styled(TextView)`
  line-height: 14px;
  top: 0px;
  right: -13px;
  position: absolute;
`;

DatePlus.displayName = 'DatePlus';
